// First-party product analytics (client). Fire-and-forget, batched, and wrapped
// so it can never throw or break the app. Events POST to our own backend
// (/api/analytics/events) — no third-party SaaS, works without external keys.
//
//   import { track, initAnalytics } from './analytics.js';
//   initAnalytics();                 // once, on app load
//   track('trip_created');           // anywhere
//   track('tab_view', { tab: 'today' });

import { safeSet } from './lib/storage.js';
const API = (import.meta && import.meta.env && import.meta.env.VITE_API_URL) || '/api';
const AID_KEY = 'analytics_aid';

function uuid() {
  try { if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID(); } catch { /* ignore */ }
  return 'a-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
}
function anonId() {
  try {
    let id = localStorage.getItem(AID_KEY);
    if (!id) { id = uuid(); safeSet(AID_KEY, id); }
    return id;
  } catch { return null; }
}
function authToken() { try { return localStorage.getItem('auth_token'); } catch { return null; } }

const SESSION_ID = uuid();   // one per page-load
let queue = [];
let timer = null;

// keepalive fetch (not sendBeacon) so we can still send the Authorization header
// on unload and keep events associated with the logged-in user.
function flush() {
  if (!queue.length) return;
  const batch = queue; queue = [];
  if (timer) { clearTimeout(timer); timer = null; }
  const headers = { 'Content-Type': 'application/json' };
  const tk = authToken(); if (tk) headers.Authorization = 'Bearer ' + tk;
  try {
    fetch(API + '/analytics/events', {
      method: 'POST',
      headers,
      keepalive: true,
      body: JSON.stringify({ anon_id: anonId(), session_id: SESSION_ID, events: batch }),
    }).catch(() => {});
  } catch { /* swallow — analytics must never break the app */ }
}

export function track(event, props) {
  try {
    if (typeof event !== 'string') return;
    let path = '';
    try { path = (location && (location.hash || location.pathname)) || ''; } catch { /* ignore */ }
    queue.push({ event, props: props && typeof props === 'object' ? props : {}, path, ts: Date.now() });
    if (queue.length >= 20) { flush(); return; }
    if (!timer) timer = setTimeout(() => { timer = null; flush(); }, 4000);
  } catch { /* ignore */ }
}

let started = false;
export function initAnalytics() {
  if (started) return; started = true;
  try {
    let ref = '';
    try { ref = document.referrer ? new URL(document.referrer).hostname : ''; } catch { /* ignore */ }
    track('session_start', { lang: (navigator.language || '').slice(0, 5), ref });
    document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') flush(); });
    window.addEventListener('pagehide', flush);
  } catch { /* ignore */ }
}

export default { track, initAnalytics };
